import { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import { useLocales } from '@/locales';

export default function MessageList({ messages, isSending }) {
  const { translate } = useLocales();
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }, [messages.length, isSending]);

  return (
    <div className="flex-1 flex flex-col gap-3 overflow-y-auto px-3 py-3">
      {messages.length === 0 && (
        <MessageBubble from="assistant" content={translate('chat_greeting')} />
      )}

      {messages.map(m => (
        <MessageBubble key={m.id} from={m.role} content={m.content} />
      ))}

      {isSending && (
        <div className="flex gap-1 px-3 text-xs text-gray-500">
          <span className="animate-pulse">●</span>
          <span className="animate-pulse [animation-delay:120ms]">●</span>
          <span className="animate-pulse [animation-delay:240ms]">●</span>
        </div>
      )}

      <div ref={endRef} />
    </div>
  );
}
